<template>
    <div id="contract_container">
            <div class="contract_contents">
                <div class="contract1apass_area_1">
                    <h5>
                       {{title}}
                    </h5>
                    <h6>
                        <div v-html="content"></div>
                        <!-- 기타 문의사항은 고객센터 또는 help@finbridge.co.kr 로 문의 부탁드립니다. -->
                    </h6>
                    <br>
                    <p>
                        <span class="bottom_sub_content">
                            [고객센터]<br>
                            - 연락처: 1688-4102<br>
                            - 업무시간: 09:00~18:00 (주말, 공휴일 휴무)<br>
                            - 점심시간: 12:00~13:00
                        </span>
                    </p>
                    <div class="form_btn">
                            <v-btn v-if="result == 'SUCCESS'" id="join_btn" style="color:#fff" color="#343A40" @click.stop="$router.push({name:'passSafeguardCs'})" >고객센터로 이동</v-btn>
                            <v-btn v-else id="back_btn" style="color:#fff" color="#007bff" @click.stop="failCall()" >서비스 선택 다시하기</v-btn>
                            <!-- <button type="button" class="btn btn-dark" id="back_btn2" @click.stop="$router.push({name:'passSafeGuard'})">고객센터로 이동</button>
                            <button type="button" class="btn btn-primary" id="re_btn">
                                서비스 선택 다시하기
                            </button> -->
                        <!-- </a> -->
                    </div>
                </div>
            </div>
            <!-- router Param 없을때 시작 -->
            <v-layout row justify-center>
            <v-dialog v-model="returnDialog" persistent max-width="290">
                <!-- <v-btn slot="activator" color="primary" dark>Open Dialog</v-btn> -->
                <v-card>
                <v-card-title class="headline"></v-card-title>
                <v-card-text style="text-align:center;">정상적인 접근이 아닙니다.</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <!-- <v-btn color="green darken-1" text @click.native="dialog = false">Disagree</v-btn> -->
                    <v-btn color="green darken-1" text @click.stop="goReturn()">확인</v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>
            </v-layout>
            <!-- router Param 없을때 끝 -->
        </div>
</template>

<script>

export default {
    name: 'app',
    data: () => ({
        //routeParams
        type:'', // contract / termination / compensation
        result:'', // SUCCESS / FAIL
        title:'',
        content:'',
        returnDialog : false,
    }),
    created() {
        // console.log("router", this.$router.name)
        // console.log("$route", this.$route.params)
      this.type = this.$route.params.type;
      this.result = this.$route.params.result;
      this.teleCoCd = this.$route.params.teleCoCd;
      this.user = this.$route.params.user;
      if(this.type == undefined){
            this.returnDialog = true
        }
    },
    mounted() {
        this.msgChange()
        
    },
    methods: {
        failCall(){
            var type = this.type        // contract / termination / compensation
            if(type === "contract"){
                this.$router.push({name:'passSafeguardContract'})
            } else if(type === "termination"){
                this.$router.push({name:'passSafeguardTermination'})
            } else if(type === "compensation"){
                this.$router.push({name:'passSafeguardCompensation'})
            }
        },
        msgChange(){
            // console.log("type : ", this.type)
            // console.log("result : ", this.result)
            // console.log("title : ", this.title)
            // console.log("content : ", this.content)
            var type = this.type        // contract / termination / compensation
            var result = this.result    // SUCCESS / FAIL
            var title = this.title
            var content = this.content
            if(type === 'contract') {
                if(result === 'SUCCESS'){
                    this.title = '가입이 완료되었습니다.'
                    this.content = '기타 문의사항은 고객센터 또는 help@finbridge.co.kr 로 문의 부탁드립니다.'
                } else if (result === 'LIMIT') {
                    this.title = '가입이 정상적으로 처리되지 않았습니다!'
                    this.content = '<div style="text-align: center">가입제한 신청자입니다.</div><br /><br />기타 문의사항은 고객센터 또는 help@finbridge.co.kr 로 문의 부탁드립니다.'
                } else {
                    this.title = '가입이 정상적으로 처리되지 않았습니다!'
                    this.content = `선택 통신사를 확인해주세요.<br />선불폰, ${this.teleCoCd === "1" ? '알뜰폰(MVNO), ' : '' }법인명의로 이용중이시거나, 미성년자, 국내거소신청자일 경우 가입할 수 없습니다. 또한, 일시정지, 미납고객의 경우 가입이 제한됩니다.<br/><br/> 기타 문의사항은 고객센터 또는 help@finbridge.co.kr로 문의 부탁드립니다.`
                }
            } else if(type === 'termination') {
                if(result === 'SUCCESS'){
                    this.title = '해지처리가 완료되었습니다.'
                    this.content = '기타 문의사항은 고객센터 또는 help@finbridge.co.kr 로 문의 부탁드립니다.'
                } else {
                    this.title = '해지처리가 정상적으로 처리되지 않았습니다!'
                    this.content = '선택하신 서비스에 현재 정상적으로 가입되어 있지 않습니다. 가입하신 서비스를 재확인하시고, 서비스 해지를 진행 부탁드립니다.<br><br>기타 문의사항은 고객센터 또는 help@finbridge.co.kr로 문의 부탁드립니다.'
                }
            } else if(type === 'compensation') {
                if(result === 'SUCCESS'){
                    this.title = '보상신청이 완료되었습니다.'
                    this.content = '접수일 기준으로 익일(영업일 기준) 전담 담당자가 고객님께 유선으로 연락드려서 신청서류 등을 상세히 안내 드릴 수 있도록 하겠습니다.<br /><br/>기타 문의사항은 고객센터 또는 help@finbridge.co.kr로 문의 부탁드립니다.';    
                } else {
                    this.title = '보상신청이 정상적으로 처리되지 않았습니다!'
                    this.content = '선택하신 서비스에 현재 정상적으로 가입되어 있지 않거나 이미 보상신청을 완료하셨습니다.<br />가입하신 서비스 또는 보상신청 내역을 재확인하시고 보상신청 진행을 부탁드립니다.<br><br>서비스 해지자에 해당하시거나 기타 문의사항이 있으신 경우 당사 이메일(help@finbridge.co.kr)로 연락 주시면 답변드리겠습니다.'
                }
            }
        },
        clearLimit() {
          this.axios
            .post("/rest/updateCustomerSubscriptionRestrictions", {
              cellTelNo: this.user.cellTelNo,
              custNm: this.user.name,
              birthDe: this.user.birth,
              genCd: this.user.genCd,
              teleCoCd: this.user.teleCoCd,
            })
            .then((result) => {
              this.goReturn();
            });
        },
        goReturn(){
          this.$router.push({name:'passSafeguardCs'})
        }
    }
}
</Script>